/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { Button, Container, Typography } from "@mui/material";

const DeletePopUp = ({ data, close, onDeleteConfirm}) => {
    return (
        <Container maxWidth="md">

            <Typography my={3} variant="h5" component="div" color="text.primary" textAlign="center" fontWeight="bold">
                Delete {data}?
            </Typography>

            <Typography my={3} component="div" color="text.primary" textAlign="center" fontWeight="400">
                Are you sure you want to delete this {data.toLowerCase()}?
            </Typography>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: "1rem" }}>
                <Button onClick={close} style={{borderRadius: '1rem', margin: '0.5rem', width: "10rem"}} fullWidth variant="contained">No</Button>
                <Button onClick={onDeleteConfirm} style={{borderRadius: '1rem', margin: '0.5rem', width: "10rem"}} fullWidth variant="contained">Yes</Button>
            </div>

        </Container>
    );
}

export default DeletePopUp